import React from "react";

import { FormFieldErrorMessage } from "~/components/form/error-message";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";
import { Switch } from "~/components/switch";
import { useScope } from "~/tools/impulse";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetDecimalsField } from "../../../widget-form/decimals";
import { WidgetUnitField } from "../../../widget-form/unit";
import { WidgetYAxisLabelField } from "../../../widget-form/y-axis";
import type { WidgetYAxis } from "../../../widget-form/y-axis/form-state";
import { SettingsSectionFormField } from "../_field";
import { SettingsSectionGrid } from "../_section-grid";

interface YAxisLabelsSectionProps {
	yAxis: WidgetYAxis;
}

export const YAxisLabelsSection: React.FC<YAxisLabelsSectionProps> = ({ yAxis }) => {
	const scope = useScope();
	const enabled = yAxis.enabled.getInput(scope);

	return (
		<Widget>
			<WidgetHeader className="grid-cols-[auto_auto_1fr] uppercase" title="Y-axis Labels">
				<Switch
					checked={enabled}
					name="dashboard-widget-y-axis-show"
					onCheckedChange={(show) => yAxis.enabled.setInput(show)}
				/>

				<FormFieldReset className="ml-auto" state={yAxis} />
			</WidgetHeader>

			<WidgetBody card>
				<SettingsSectionGrid className="grid-cols-[auto_1fr]">
					<SettingsSectionFormField layout="horizontal" state={yAxis.element.fields.unit}>
						<FormLabel>Unit</FormLabel>

						<WidgetUnitField
							className="w-full"
							default={undefined}
							disabled={!enabled}
							unit={yAxis.element.fields.unit}
						/>
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={yAxis.element.fields.decimals}>
						<FormLabel>Decimals</FormLabel>

						<WidgetDecimalsField
							decimals={yAxis.element.fields.decimals}
							disabled={!enabled}
							name="dashboard-widget-settings-decimal-places"
						/>

						<FormFieldErrorMessage className="col-span-full" />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={yAxis.element.fields.label}>
						<FormLabel>Label</FormLabel>

						<WidgetYAxisLabelField
							disabled={!enabled}
							label={yAxis.element.fields.label}
							name="dashboard-widget-y-axis-label"
						/>
					</SettingsSectionFormField>
				</SettingsSectionGrid>
			</WidgetBody>
		</Widget>
	);
};
